import { render, staticRenderFns } from "./LoginOrSignupLayout.vue?vue&type=template&id=bce0c230&scoped=true&"
import script from "./LoginOrSignupLayout.vue?vue&type=script&lang=js&"
export * from "./LoginOrSignupLayout.vue?vue&type=script&lang=js&"
import style0 from "./LoginOrSignupLayout.vue?vue&type=style&index=0&id=bce0c230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce0c230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VContainer,VContent,VFooter,VImg,VRow,VSpacer,VToolbar,VToolbarTitle})
